<template>
  <div :class="{'v-check': data.isRequired}">
    <div v-if="data.decreaseable">
      <el-input
        :type="data.type?data.type:'text'"
        rows="5"
        v-checkParams="checkParams"
        v-model="data.controlValue"
        :placeholder="data.controlDefValue"
        style="width:80%"
        clearable
      ></el-input>
      <div class="el-i-minus">
        <i class="el-icon-minus"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TpInput',
  inject: ['formData', 'rules'],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      checkParams: ''
    }
  },
  methods: {
  },
  created () {
    this.checkParams = (this.data.isRequired ? 'required' : '') + (this.data.checkParams ? '|' + this.data.checkParams : '')
  }
}

</script>
<style>
.error .el-input input {
  border-color: #f56c6c;
  color: #f56c6c;
}
.flex {
  display: flex;
}
.inNumber {
  width: 305px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/input.vue